import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

function VendorRejectionAgent() {
  useEffect(() => {
    // Only load script once
    if (!document.getElementById("wxo-vendor-script")) {
      window.wxOConfiguration = {
        orchestrationID:
          "70d163a79ddf4e54925d1e85aca292ea_c57ab471-e099-4df6-82e3-1f9dd0d7e05a",
        hostURL: "https://au-syd.watson-orchestrate.cloud.ibm.com",
        rootElementID: "vendor-orchestrate-chat-root", // ✅ unique container
        deploymentPlatform: "ibmcloud",
        crn: "crn:v1:bluemix:public:watsonx-orchestrate:au-syd:a/70d163a79ddf4e54925d1e85aca292ea:c57ab471-e099-4df6-82e3-1f9dd0d7e05a::",
        chatOptions: {
          agentId: "0d1499e0-403d-40ab-8677-8c1f91bec775",
        },
      };

      const script = document.createElement("script");
      script.id = "wxo-vendor-script";
      script.src = `${window.wxOConfiguration.hostURL}/wxochat/wxoLoader.js?embed=true`;
      script.async = true;
      script.onload = () => {
        if (window.wxoLoader) window.wxoLoader.init();
      };
      document.body.appendChild(script);
    } else {
      // If script already exists, just re-init
      if (window.wxoLoader) window.wxoLoader.init();
    }

    return () => {
      // Clean up chat content only
      const chatRoot = document.getElementById("vendor-orchestrate-chat-root");
      if (chatRoot) chatRoot.innerHTML = "";
    };
  }, []);

  return (
    <>
      {/* Hero Section */}
      <div
        className="text-center text-white bg_header mb-5"
        style={{
          background:
            "url('https://img.freepik.com/free-photo/logistics-transportation-cargo-container-shipping_34200-273.jpg') center/cover",
          padding: "180px 0",
        }}
      >
        <h1 className="fw-bold mb-4">
          <span className="primary_text">Vendor Rejection Analysis Agent</span>
        </h1>
        <p className="mb-5">
          Gain actionable insights into supplier performance and reduce risks
          with <span className="primary_text">AI-powered analytics</span>.
        </p>
      </div>

      {/* Features Section */}
      <div className="container mt-5">
        <div className="row text-center invoice_box">
          <div className="col-md-4 mb-4">
            <div className="feature-box">
              <h4>📊 Rejection Trends</h4>
              <p>
                Identify supplier rejection rates and track quality performance
                over time.
              </p>
            </div>
          </div>
          <div className="col-md-4 mb-4">
            <div className="feature-box">
              <h4>🔍 Root Cause Insights</h4>
              <p>
                Analyze reasons for rejections and detect recurring quality
                issues.
              </p>
            </div>
          </div>
          <div className="col-md-4 mb-4">
            <div className="feature-box">
              <h4>⚡ Predictive Risk Detection</h4>
              <p>
                Use AI predictions to spot high-risk suppliers before they cause
                disruptions.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Advantages Section */}
      <div className="container my-5">
        <h2 className="text-center mb-4">🌟 Advantages of Using This Agent</h2>
        <div className="row text-center">
          <div className="col-md-3 mb-4">
            <div className="p-3 shadow-sm rounded">
              <h5>✔ Improved Quality</h5>
              <p>Reduce defects and ensure suppliers maintain quality standards.</p>
            </div>
          </div>
          <div className="col-md-3 mb-4">
            <div className="p-3 shadow-sm rounded">
              <h5>✔ Cost Savings</h5>
              <p>Minimize rework, warranty claims, and production downtime.</p>
            </div>
          </div>
          <div className="col-md-3 mb-4">
            <div className="p-3 shadow-sm rounded">
              <h5>✔ Faster Decisions</h5>
              <p>Instant AI-driven analysis speeds up supplier evaluations.</p>
            </div>
          </div>
          <div className="col-md-3 mb-4">
            <div className="p-3 shadow-sm rounded">
              <h5>✔ Compliance Ready</h5>
              <p>Ensure regulatory compliance with detailed rejection tracking.</p>
            </div>
          </div>
        </div>
      </div>

      {/* How It Works Section */}
      <div className="container my-5">
        <h2 className="text-center mb-4">⚙️ How It Works</h2>
        <div className="row">
          <div className="col-md-4 text-center">
            <h5>1️⃣ Data Collection</h5>
            <p>Collects vendor rejection records and quality reports.</p>
          </div>
          <div className="col-md-4 text-center">
            <h5>2️⃣ AI Analysis</h5>
            <p>AI models analyze patterns, detect anomalies, and find root causes.</p>
          </div>
          <div className="col-md-4 text-center">
            <h5>3️⃣ Actionable Insights</h5>
            <p>
              Provides dashboards, recommendations, and predictive alerts for
              supplier management.
            </p>
          </div>
        </div>
      </div>

      {/* Agentic AI Section */}
      <div className="container my-5">
        <div className="card shadow-lg p-4">
          <h3 className="text-center mb-3">🤖 How Agentic AI Enhances It</h3>
          <p className="text-center mb-4">
            Agentic AI doesn’t just analyze—it acts on insights. It can trigger
            workflows, alert procurement teams, and even suggest supplier
            alternatives proactively.
          </p>
          <ul>
            <li>🔔 Automated alerts when supplier rejection rates exceed limits.</li>
            <li>📧 Integration with procurement tools for instant notifications.</li>
            <li>🔄 Continuous learning to improve predictions over time.</li>
            <li>🧠 Acts as a digital co-pilot for your quality and supply chain team.</li>
          </ul>
        </div>
      </div>

      {/* Watson Chat Embed */}
      <div className="container my-5">
        <div className="card shadow-lg p-4">
          <h3 className="text-center mb-3">Interact with the Vendor Rejection Agent</h3>
          <p className="text-center">
            Ask questions, analyze rejection trends, and explore supplier insights instantly.
          </p>
          <div
            id="vendor-orchestrate-chat-root" // ✅ unique div for this agent
          ></div>
        </div>
      </div>
    </>
  );
}

export default VendorRejectionAgent;
